import { Injectable } from '@angular/core';
import { Choice } from '../models/choice';
import { Decision } from '../models/decision';

@Injectable({
  providedIn: 'root'
})
export class DecisionService {
  constructor(){}

  mapValuesToDecision(rawData: any): Decision[] {
    let decisions: any[] = [];
    let that = this;

    rawData
      .filter((d: any) => d.enable == true)
      .forEach((data: any) => {
        decisions.push(that.buildDecisionMap(data));    
      });

    return decisions;
  }

  getCurrentPathway(decisions : Decision[]): Choice | undefined {
    let choice;
    decisions.forEach((decision) => {
      if(decision.nthDecision == 1) {
        choice = decision.selectedOption;
      }
    });
    return choice;
  }

  private buildDecisionMap(data: any): Decision {
    var choices: Choice[] = this.buildChoices(data.options);    
    
    return new Decision(data.nthDecision, 
        data.enable, 
        data.required,
        data.question, 
        choices, 
        data.description, 
        data.tips, 
        data.image,
        data.nextTitle, 
        data.nextAction, 
        data.previousTitle, 
        data.previousAction, 
        data.filler);
  }

  private buildChoices(options: any) : Choice[] {
    var choices : Choice[] = [];

    if(!! options) {
      options
        .filter((option: any) => option.enable)
        .forEach((option: any) => {
          var choice = new Choice(option.enable, option.title, option.name, option.subject, option.image);
          choices.push(choice);
        });
    }

    return choices;
  }

}
